export default "__VITE_ASSET__6932a645__"